import { Component, signal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataTable, IDataClassConfig } from "app/classes/data-table/data-table";
import { Gateway } from "app/classes/gateway";
import { APIService } from "app/shared/api.service";
import { GatewayService, SimpleGateway } from "app/shared/gateway.service";

@Component({
  selector: "app-grafana-list",
  standalone: false,
  templateUrl: "./grafana-list.component.html",
  styleUrl: "./grafana-list.component.css",
})
export class GrafanaListComponent {

  gatewayList = signal<SimpleGateway[]>([]);

  dataTable = signal<DataTable>(null);
  dataTableConfig: IDataClassConfig = {
    "sTitle": { "valueType": "string", "title": "Site", "align": "left" },
    "title": { "valueType": "string", "title": "Gateway", "align": "left" },
    "oTitle": { "valueType": "string", "title": "Org", "align": "left" },
    "wTemp": { "valueType": "number", "title": "Temp", "align": "right", width: 70 },
    "wPressure": { "valueType": "number", "title": "Pressure", "align": "right", width: 70 },
    "wCSS": { "valueType": "weatherIcon", "title": "Icon", "align": "right", width: 40 }
  };

  filterText = "";
  filterCount: number;

  constructor(private apiService: APIService, private gatewayService: GatewayService, private router: Router, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.gatewayList.set([]);

    this.gatewayService.getGrafanaGateways().then(g => {
      this.gatewayList.set(g);
      this.dataTable.set(new DataTable({ data: g, sortedColumns: null }, this.dataTableConfig));
    });
  }

  rowClick(gateway: SimpleGateway) {
    console.log(gateway);
    this.router.navigate([gateway.id], { relativeTo: this.activatedRoute });
  };

  searchChanged(searchText: string) { };
}
